export interface BackendCommand<TRequest, TResponse> {
  name: string;
  options?: BackendCommandOptions;
  readonly __types?: {
    request: TRequest;
    response: TResponse;
  };
}

export interface BackendCommandOptions {
  timeoutMs?: number;
}

export function defineBackendCommand<TRequest, TResponse>(
  name: string,
  options?: BackendCommandOptions,
): BackendCommand<TRequest, TResponse> {
  return options ? { name, options } : { name };
}

export interface CommandClient {
  call<TRequest, TResponse>(
    command: BackendCommand<TRequest, TResponse>,
    request: TRequest,
  ): Promise<TResponse>;
}
